import { useEffect } from "react";

/**
 * Custom hook to dynamically update the favicon based on the user's color scheme preference.
 * Switches between black and white logo variants for light and dark modes respectively.
 */
export const useDynamicFavicon = () => {
  useEffect(() => {
    const updateFavicon = (isDarkMode: boolean) => {
      const favicon = document.querySelector(
        "link[rel='icon']",
      ) as HTMLLinkElement;
      if (favicon) {
        favicon.href = isDarkMode ? "/favicon-white.svg" : "/favicon.svg";
      }
    };

    // Check the current color scheme preference
    const darkModeMediaQuery = window.matchMedia(
      "(prefers-color-scheme: dark)",
    );

    // Set initial favicon based on current preference
    updateFavicon(darkModeMediaQuery.matches);

    // Listen for changes to the color scheme preference
    const handleChange = (e: MediaQueryListEvent) => {
      updateFavicon(e.matches);
    };

    // Add event listener (using addEventListener for better browser support)
    darkModeMediaQuery.addEventListener("change", handleChange);

    // Cleanup function to remove the event listener
    return () => {
      darkModeMediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
};
